
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "AllPatient": [
      "CheckinEntry",
      "DirectVisitor",
      "LineVisitor",
      "Patient",
      "WebVisitor"
    ],
    "DirectVisitorCandidate": [
      "CheckinEntry",
      "DirectVisitor"
    ],
    "DisclosedMedicineNote": [
      "HiccupOnetimeApiCache",
      "HiccupTemporaryPermission"
    ],
    "Event": [
      "GuestPatientMedicationFollowupComment",
      "MedicationFollowupMessage",
      "MedicationFollowupQuestionnaireSheet",
      "PatientMedicationFollowupComment",
      "TracingReport"
    ],
    "FeatureTarget": [
      "Company",
      "Organization",
      "Patient",
      "Practitioner"
    ],
    "FeeSetting": [
      "CompanyFeeSetting",
      "OrganizationCompanyFeeSetting",
      "OrganizationFeeSetting"
    ],
    "GuestPatient": [
      "DirectVisitor",
      "LineVisitor",
      "WebVisitor"
    ],
    "LoginUser": [
      "Operator",
      "Practitioner"
    ],
    "MedicationFollowupComment": [
      "GuestPatientMedicationFollowupComment",
      "PatientMedicationFollowupComment"
    ],
    "MedixsPatientQuestionnaireSheet": [
      "OutpatientQuestionnaireEntry",
      "QuestionnaireSheet"
    ],
    "Node": [
      "Address",
      "Agent",
      "AgentPackage",
      "AgentPackageFile",
      "AgentRelease",
      "AgentReleaseFile",
      "AgreementExtension",
      "AllowList",
      "Announcement",
      "Appointment",
      "AppointmentsYakumaruPrescriptionIdentificationResult",
      "B2cloudSetting",
      "BankAccount",
      "Bookmark",
      "Charge",
      "ChargeHistory",
      "CheckinEntry",
      "CheckinOrganization",
      "ClientAuthentication",
      "ClientCert",
      "ClientCertJobInformation",
      "Company",
      "CompanyAddress",
      "CompanyCommonSetting",
      "CompanyContactPoint",
      "CompanyFeeSetting",
      "CompanyPasswordSetting",
      "CompanyPaymentExaminationInformationSubmission",
      "CompanyPractitioner",
      "CompanyPractitionerConfirmation",
      "CompanyPractitionerContactPoint",
      "CompanySessionSetting",
      "CompanySetupDocument",
      "CompanyWebBookingsLimitSetting",
      "ContactPoint",
      "Contract",
      "ContractPlan",
      "DirectVisitor",
      "DraftAppointment",
      "Encounter",
      "Extension",
      "FaximoSendFax",
      "Feature",
      "FeatureTargetGroup",
      "FeatureUsage",
      "GendaApiKey",
      "GendaSetting",
      "GuestPatientMedicationFollowupComment",
      "HiccupAppointmentPermission",
      "HiccupOnetimeApiCache",
      "HiccupTemporaryPermission",
      "InvitationCode",
      "Invoice",
      "LineAccountSetting",
      "LineVisitor",
      "MedicalInstitutionSetting",
      "MedicationFollowupAutoReplySetting",
      "MedicationFollowupAutoReplySettingTemplate",
      "MedicationFollowupDraftMessage",
      "MedicationFollowupMessage",
      "MedicationFollowupMessageTemplate",
      "MedicationFollowupMessageTemplateJobInformation",
      "MedicationFollowupQuestionnaire",
      "MedicationFollowupQuestionnaireRevision",
      "MedicationFollowupQuestionnaireSheet",
      "MedicationFollowupSetting",
      "MedixsPatient",
      "MedixsReception",
      "MedixsSetting",
      "MessageDeliver",
      "MessageDeliverResult",
      "Operator",
      "OperatorAccessPermission",
      "OperatorRole",
      "Organization",
      "OrganizationAddress",
      "OrganizationBusinessHour",
      "OrganizationCompanyFeeSetting",
      "OrganizationContactPoint",
      "OrganizationFeeSetting",
      "OrganizationImportJobInformation",
      "OrganizationMasterMedicalInformationNet",
      "OrganizationNotification",
      "OrganizationNotificationSetting",
      "OrganizationTelNotificationSuspension",
      "OutpatientQuestionnaire",
      "OutpatientQuestionnaireEntry",
      "OutpatientQuestionnaireOrganization",
      "OutpatientQuestionnaireQuestion",
      "OutpatientQuestionnaireSetting",
      "OutpatientQuestionnaireSettingQuestionnaire",
      "Patient",
      "PatientAttachment",
      "PatientMedicationFollowupComment",
      "PaymentExaminationUploadJobInformation",
      "Payout",
      "PayoutBankAccount",
      "PayoutOrganization",
      "PayoutSubject",
      "PfDispensingRequest",
      "PfPatient",
      "PfPrescriptionImage",
      "Plan",
      "PlanFeature",
      "Practitioner",
      "PractitionerOtpSecret",
      "PractitionerSigninHistory",
      "PrivilegeOrganization",
      "PrivilegeOrganizationPractitioner",
      "PublicAddress",
      "PublicAppointment",
      "PublicCheckinEntry",
      "PublicMedicationFollowupMessage",
      "PublicMedicationFollowupQuestionnaireRevision",
      "PublicMedicationFollowupQuestionnaireSheet",
      "PublicOrganization",
      "PublicOrganizationAddress",
      "PublicOutpatientQuestionnaireEntry",
      "PublicSignupPfPatientInformation",
      "PublicSignupPfPatientInformationOrganization",
      "PublicSlot",
      "PublicWebBookingsSetting",
      "RefundHistory",
      "SendgridEventActivity",
      "TracingReport",
      "TracingReportDraft",
      "UberDelivery",
      "UberOrganization",
      "UberOrganizationImportJobInformation",
      "UberOrganizationSetting",
      "UberOrganizationSettingJobInformation",
      "UberSignature",
      "UberSignatureDraft",
      "WebBookingsBusinessHour",
      "WebBookingsExceptionBusinessHour",
      "WebBookingsHolidayBusinessHour",
      "WebBookingsLimit",
      "WebBookingsSetting",
      "WebBookingsSuspend",
      "WebVisitor",
      "YakumaruCompanySetting",
      "YakumaruOrganizationSetting",
      "YakumaruOrganizationSettingJobInformation"
    ],
    "Reception": [
      "Appointment",
      "CheckinEntry",
      "DraftAppointment",
      "OutpatientQuestionnaireEntry"
    ]
  }
};
      export default result;
    